export default __webpack_public_path__ + "static/media/keep_going.4e50d747.mp3";